"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignMethods = exports.Campaign = void 0;

var _numbers = require("../../utils/numbers");

var _strings = require("../../utils/strings");

var _campaignGoal = require("./campaignGoal");

var _product = require("../product");

var _moment = _interopRequireDefault(require("moment"));

var _hashtags_and_handles = require("../../utils/hashtags_and_handles");

var _campaignAttachment = require("./campaignAttachment");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CampaignMethods = /*#__PURE__*/function () {
  function CampaignMethods() {
    _classCallCheck(this, CampaignMethods);
  }

  _createClass(CampaignMethods, null, [{
    key: "getName",
    value: function getName(campaign) {
      return (0, _strings.decodeUTF8)(campaign.name);
    }
  }, {
    key: "isLinkTracking",
    value: function isLinkTracking(campaign) {
      return !!campaign.link_tracking;
    }
  }, {
    key: "getStartMoment",
    value: function getStartMoment(campaign) {
      return campaign.starts_at ? (0, _moment["default"])(campaign.starts_at) : undefined;
    }
  }, {
    key: "getEndMoment",
    value: function getEndMoment(campaign) {
      return campaign.ends_at ? (0, _moment["default"])(campaign.ends_at) : undefined;
    }
  }, {
    key: "hasInfluencers",
    value: function hasInfluencers(campaign) {
      // The invited count represents the number of influencers added to the campaign (not just invited)
      // in other words, campaign field represents the number of campaign_influencers associated with campaign campaign
      return campaign.invited && campaign.invited > 0;
    }
  }, {
    key: "isNameValid",
    value: function isNameValid(campaign) {
      return !!campaign.name;
    }
  }, {
    key: "getValidDateFormat",
    value: function getValidDateFormat() {
      return 'YYYY-MM-DD';
    }
  }, {
    key: "isP4PValid",
    value: function isP4PValid(campaign) {
      if (!campaign.has_product_for_post) {
        return true;
      }

      return !!campaign.shop_id && !!campaign.products.length && !!campaign.shop_type;
    }
  }, {
    key: "isDatesValid",
    value: function isDatesValid(campaign) {
      // End date must be after start date
      // Parse the date in strict mode to check for invalid dates (like 6 character year value)
      // https://momentjs.com/docs/#/parsing/string-format/
      if (!campaign.starts_at || !campaign.ends_at || !(0, _moment["default"])(campaign.starts_at, CampaignMethods.getValidDateFormat(), true).isValid() || !(0, _moment["default"])(campaign.ends_at, CampaignMethods.getValidDateFormat(), true).isValid() || (0, _moment["default"])(campaign.ends_at).isBefore((0, _moment["default"])(campaign.starts_at))) {
        return false;
      }

      return true;
    } // Every campaign MUST have one hashtags, handles, or phrases.

  }, {
    key: "hasTags",
    value: function hasTags(campaign) {
      var hashtags = campaign.hashtags,
          handles = campaign.handles,
          phrases = campaign.phrases;
      var allTags = [].concat(_toConsumableArray(hashtags !== null && hashtags !== void 0 ? hashtags : []), _toConsumableArray(handles !== null && handles !== void 0 ? handles : []), _toConsumableArray(phrases !== null && phrases !== void 0 ? phrases : []));

      if (allTags.length < 1) {
        return false;
      }

      return true;
    }
  }, {
    key: "hasAllValidTags",
    value: function hasAllValidTags(campaign) {
      if (!CampaignMethods.hasTags(campaign)) {
        return false;
      }

      var hashtags = campaign.hashtags,
          handles = campaign.handles,
          and_hashtags = campaign.and_hashtags;
      var allTags = [].concat(_toConsumableArray(hashtags !== null && hashtags !== void 0 ? hashtags : []), _toConsumableArray(handles !== null && handles !== void 0 ? handles : []), _toConsumableArray(and_hashtags !== null && and_hashtags !== void 0 ? and_hashtags : []));
      return (0, _hashtags_and_handles.validateAllHashtagsAndHandles)(allTags);
    }
  }, {
    key: "areGoalsValid",
    value: function areGoalsValid(campaign) {
      var goals = campaign.goals;
      return (goals !== null && goals !== void 0 ? goals : []).every(function (goal) {
        return _campaignGoal.CampaignGoalMethods.isGoalValid(goal);
      });
    }
  }, {
    key: "isReviewIntervalValid",
    value: function isReviewIntervalValid(campaign) {
      var review_email_interval_days = campaign.review_email_interval_days;
      return review_email_interval_days === null || !!review_email_interval_days && Number.isInteger(review_email_interval_days);
    }
  }, {
    key: "getInstagramGoals",
    value: function getInstagramGoals(campaign) {
      var _campaign$goals;

      return (_campaign$goals = campaign.goals) === null || _campaign$goals === void 0 ? void 0 : _campaign$goals.find(function (f) {
        return f.source === 'instagram';
      });
    }
  }, {
    key: "hasReviewsEnabled",
    value: function hasReviewsEnabled(campaign) {
      return !!campaign.review_email_interval_days;
    }
  }, {
    key: "getTikTokGoals",
    value: function getTikTokGoals(campaign) {
      var _campaign$goals2;

      return (_campaign$goals2 = campaign.goals) === null || _campaign$goals2 === void 0 ? void 0 : _campaign$goals2.find(function (f) {
        return f.source === 'tiktok';
      });
    }
  }, {
    key: "isValidLinkTracking",
    value: function isValidLinkTracking(campaign) {
      var link_url = campaign.link_url,
          products = campaign.products,
          link_name = campaign.link_name,
          link_tracking = campaign.link_tracking;

      if (!link_tracking) {
        return true;
      }

      if (link_url || link_name) {
        // If one exists so does the other and it has to be valid
        return !!link_url && !!link_name && (link_url.startsWith('https://') || link_url.startsWith('http://'));
      } // If no link info is supplied, products must be supplied


      return !!products.length;
    }
    /*  Every campaign MUST have one of the following. We separate them in the DB
      but for the purposes of validation we bring them back together here */

  }, {
    key: "getRequiredTags",
    value: function getRequiredTags(campaign) {
      var hashtags = campaign.hashtags,
          handles = campaign.handles,
          phrases = campaign.phrases;
      return [].concat(_toConsumableArray(hashtags !== null && hashtags !== void 0 ? hashtags : []), _toConsumableArray(handles !== null && handles !== void 0 ? handles : []), _toConsumableArray(phrases !== null && phrases !== void 0 ? phrases : []));
    }
  }, {
    key: "getOptionalTags",
    value: function getOptionalTags(campaign) {
      var _campaign$and_hashtag;

      return _toConsumableArray((_campaign$and_hashtag = campaign.and_hashtags) !== null && _campaign$and_hashtag !== void 0 ? _campaign$and_hashtag : []);
    }
  }, {
    key: "sanitizeTags",
    value: function sanitizeTags(tags) {
      return tags.map(function (tag) {
        return (0, _strings.encodeUTF8)(tag);
      });
    }
  }, {
    key: "hasDestinationLink",
    value: function hasDestinationLink(campaign) {
      return campaign.link_tracking && !!campaign.link_name && !!campaign.link_url;
    }
  }, {
    key: "hasProducts",
    value: function hasProducts(campaign) {
      return campaign.products.length > 0;
    }
  }, {
    key: "getDestinationLinkName",
    value: function getDestinationLinkName(campaign) {
      return (0, _strings.decodeUTF8)(campaign.link_name);
    }
  }, {
    key: "getDestinationLinkUrl",
    value: function getDestinationLinkUrl(campaign) {
      return (0, _strings.decodeUTF8)(campaign.link_url);
    }
  }, {
    key: "getTraffic",
    value: function getTraffic(campaign) {
      return campaign.traffic.toLocaleString();
    }
  }, {
    key: "getConversions",
    value: function getConversions(campaign) {
      var _campaign$conversion;

      return (_campaign$conversion = campaign.conversion) === null || _campaign$conversion === void 0 ? void 0 : _campaign$conversion.toLocaleString();
    }
  }, {
    key: "getConversionDollarFormatted",
    value: function getConversionDollarFormatted(campaign) {
      return (0, _numbers.priceWithCurrency)(campaign.conversion_dollar);
    }
  }, {
    key: "getValueFormatted",
    value: function getValueFormatted(campaign) {
      return (0, _numbers.priceWithCurrency)(campaign.value);
    }
  }, {
    key: "getCostFormatted",
    value: function getCostFormatted(campaign) {
      return (0, _numbers.priceWithCurrency)(campaign.cost);
    }
  }, {
    key: "getTotalReachFormatted",
    value: function getTotalReachFormatted(campaign) {
      var _campaign$total_reach;

      return (0, _numbers.compactIntWithDecimals)((_campaign$total_reach = campaign.total_reach) !== null && _campaign$total_reach !== void 0 ? _campaign$total_reach : 0, 1);
    }
  }, {
    key: "getTotalImpressionsFormatted",
    value: function getTotalImpressionsFormatted(campaign) {
      var _campaign$total_impre;

      return (0, _numbers.compactIntWithDecimals)((_campaign$total_impre = campaign.total_impressions) !== null && _campaign$total_impre !== void 0 ? _campaign$total_impre : 0, 1);
    }
  }, {
    key: "isActive",
    value: function isActive(campaign) {
      var today = (0, _moment["default"])();
      var startDate = (0, _moment["default"])(campaign.starts_at).startOf('day');
      var endDate = (0, _moment["default"])(campaign.ends_at).endOf('day');
      return today.isBetween(startDate, endDate);
    }
  }, {
    key: "getROI",
    value: function getROI(campaign) {
      var result = campaign.cost === 0 || campaign.value === undefined || campaign.cost === undefined ? 0 : (campaign.value - campaign.cost) / campaign.cost * 100;
      return "".concat(result.toFixed(2), "%");
    }
  }, {
    key: "isCampaignBeingUpdated",
    value: function isCampaignBeingUpdated(campaign) {
      return campaign.$$uiPending;
    }
  }, {
    key: "isValid",
    value: function isValid(campaign) {
      return CampaignMethods.isNameValid(campaign) && CampaignMethods.isDatesValid(campaign) && CampaignMethods.hasAllValidTags(campaign) && CampaignMethods.areGoalsValid(campaign) && CampaignMethods.isReviewIntervalValid(campaign) && CampaignMethods.isValidLinkTracking(campaign) && CampaignMethods.isP4PValid(campaign);
    }
  }]);

  return CampaignMethods;
}();
/**
 * @deprecated. Use the campaign methods instead.
 */


exports.CampaignMethods = CampaignMethods;

/**
 * @deprecated. Use the campaign methods instead.
 */
var Campaign = /*#__PURE__*/function () {
  function Campaign() {
    var _data$goals, _data$attachments$map, _data$attachments, _data$products$map, _data$products;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Campaign);

    _defineProperty(this, "name", '');

    _defineProperty(this, "description", '');

    _defineProperty(this, "starts_at", null);

    _defineProperty(this, "ends_at", null);

    _defineProperty(this, "hashtags", []);

    _defineProperty(this, "handles", []);

    _defineProperty(this, "phrases", []);

    _defineProperty(this, "and_hashtags", []);

    _defineProperty(this, "products", []);

    _defineProperty(this, "link_tracking", false);

    _defineProperty(this, "link_name", '');

    _defineProperty(this, "link_url", '');

    _defineProperty(this, "utm_medium", '');

    _defineProperty(this, "utm_campaign", '');

    _defineProperty(this, "utm_source", '');

    _defineProperty(this, "invited", 0);

    _defineProperty(this, "attachments", []);

    _defineProperty(this, "goals", []);

    _defineProperty(this, "review_email_interval_days", null);

    _defineProperty(this, "reward_type", null);

    _defineProperty(this, "reward_notes", '');

    _defineProperty(this, "max_products", null);

    Object.assign(this, _objectSpread(_objectSpread({}, data), {}, {
      goals: ((_data$goals = data.goals) !== null && _data$goals !== void 0 ? _data$goals : []).map(function (goal) {
        return new _campaignGoal.CampaignGoal(goal);
      }),
      attachments: (_data$attachments$map = (_data$attachments = data.attachments) === null || _data$attachments === void 0 ? void 0 : _data$attachments.map(function (m) {
        return new _campaignAttachment.CampaignAttachment(m);
      })) !== null && _data$attachments$map !== void 0 ? _data$attachments$map : [],
      products: (_data$products$map = (_data$products = data.products) === null || _data$products === void 0 ? void 0 : _data$products.map(function (product) {
        return new _product.Product(product);
      })) !== null && _data$products$map !== void 0 ? _data$products$map : [],
      starts_at: data.starts_at ? (0, _moment["default"])(data.starts_at).format('YYYY-MM-DD') : null,
      ends_at: data.ends_at ? (0, _moment["default"])(data.ends_at).format('YYYY-MM-DD') : null,
      name: data.name ? (0, _strings.decodeUTF8)(data.name) : ''
    }));
  }

  _createClass(Campaign, [{
    key: "getName",
    value: function getName() {
      return (0, _strings.decodeUTF8)(this.name);
    }
  }, {
    key: "getStartMoment",
    value: function getStartMoment() {
      return this.starts_at ? (0, _moment["default"])(this.starts_at) : undefined;
    }
  }, {
    key: "getEndMoment",
    value: function getEndMoment() {
      return this.ends_at ? (0, _moment["default"])(this.ends_at) : undefined;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.isNameValid() && this.isDatesValid() && this.hasAllValidTags() && this.areGoalsValid() && this.isReviewIntervalValid() && this.isValidLinkTracking() && this.isP4PValid();
    }
  }, {
    key: "hasInfluencers",
    value: function hasInfluencers() {
      // The invited count represents the number of influencers added to the campaign (not just invited)
      // in other words, this field represents the number of campaign_influencers associated with this campaign
      return this.invited > 0;
    }
  }, {
    key: "isNameValid",
    value: function isNameValid() {
      if (!this.name) {
        return false;
      }

      return true;
    }
  }, {
    key: "getValidDateFormat",
    value: function getValidDateFormat() {
      return 'YYYY-MM-DD';
    }
  }, {
    key: "isP4PValid",
    value: function isP4PValid() {
      if (!this.has_product_for_post) {
        return true;
      }

      return !!this.shop_id && !!this.products.length && !!this.shop_type;
    }
  }, {
    key: "isDatesValid",
    value: function isDatesValid() {
      // End date must be after start date
      // Parse the date in strict mode to check for invalid dates (like 6 character year value)
      // https://momentjs.com/docs/#/parsing/string-format/
      if (!this.starts_at || !this.ends_at || !(0, _moment["default"])(this.starts_at, this.getValidDateFormat(), true).isValid() || !(0, _moment["default"])(this.ends_at, this.getValidDateFormat(), true).isValid() || (0, _moment["default"])(this.ends_at).isBefore((0, _moment["default"])(this.starts_at))) {
        return false;
      }

      return true;
    }
  }, {
    key: "hasAllValidTags",
    value: function hasAllValidTags() {
      if (!this.hasTags()) {
        return false;
      }

      var hashtags = this.hashtags,
          handles = this.handles,
          and_hashtags = this.and_hashtags;
      var allTags = [].concat(_toConsumableArray(hashtags), _toConsumableArray(handles), _toConsumableArray(and_hashtags));
      return (0, _hashtags_and_handles.validateAllHashtagsAndHandles)(allTags);
    } // Every campaign MUST have one hashtags, handles, or phrases.

  }, {
    key: "hasTags",
    value: function hasTags() {
      var hashtags = this.hashtags,
          handles = this.handles,
          phrases = this.phrases;
      var allTags = [].concat(_toConsumableArray(hashtags), _toConsumableArray(handles), _toConsumableArray(phrases));

      if (allTags.length < 1) {
        return false;
      }

      return true;
    }
  }, {
    key: "areGoalsValid",
    value: function areGoalsValid() {
      var goals = this.goals;
      return goals.every(function (goal) {
        return goal.isGoalValid();
      });
    }
  }, {
    key: "isReviewIntervalValid",
    value: function isReviewIntervalValid() {
      var review_email_interval_days = this.review_email_interval_days;
      return review_email_interval_days === null || !!review_email_interval_days && Number.isInteger(review_email_interval_days);
    }
  }, {
    key: "getInstagramGoals",
    value: function getInstagramGoals() {
      var _this$goals;

      return (_this$goals = this.goals) === null || _this$goals === void 0 ? void 0 : _this$goals.find(function (f) {
        return f.source === _campaignGoal.CampaignGoalTypes.Instagram;
      });
    }
  }, {
    key: "hasReviewsEnabled",
    value: function hasReviewsEnabled() {
      return !!this.review_email_interval_days;
    }
  }, {
    key: "getTikTokGoals",
    value: function getTikTokGoals() {
      var _this$goals2;

      return (_this$goals2 = this.goals) === null || _this$goals2 === void 0 ? void 0 : _this$goals2.find(function (f) {
        return f.source === _campaignGoal.CampaignGoalTypes.Tiktok;
      });
    }
  }, {
    key: "isValidLinkTracking",
    value: function isValidLinkTracking() {
      var link_url = this.link_url,
          products = this.products,
          link_name = this.link_name,
          link_tracking = this.link_tracking;

      if (!link_tracking) {
        return true;
      }

      if (link_url || link_name) {
        // If one exists so does the other and it has to be valid
        return !!link_url && !!link_name && (link_url.startsWith('https://') || link_url.startsWith('http://'));
      } // If no link info is supplied, products must be supplied


      return !!products.length;
    }
    /*  Every campaign MUST have one of the following. We separate them in the DB
    but for the purposes of validation we bring them back together here */

  }, {
    key: "getRequiredTags",
    value: function getRequiredTags() {
      var hashtags = this.hashtags,
          handles = this.handles,
          phrases = this.phrases;
      return [].concat(_toConsumableArray(hashtags), _toConsumableArray(handles), _toConsumableArray(phrases));
    }
  }, {
    key: "getOptionalTags",
    value: function getOptionalTags() {
      return _toConsumableArray(this.and_hashtags);
    }
  }, {
    key: "sanitizeTags",
    value: function sanitizeTags(tags) {
      return tags.map(function (tag) {
        return (0, _strings.encodeUTF8)(tag);
      });
    }
  }, {
    key: "hasDestinationLink",
    value: function hasDestinationLink() {
      return this.link_tracking && !!this.link_name && !!this.link_url;
    }
  }, {
    key: "hasProducts",
    value: function hasProducts() {
      return this.products.length > 0;
    }
  }, {
    key: "getDestinationLinkName",
    value: function getDestinationLinkName() {
      return (0, _strings.decodeUTF8)(this.link_name);
    }
  }, {
    key: "getDestinationLinkUrl",
    value: function getDestinationLinkUrl() {
      return (0, _strings.decodeUTF8)(this.link_url);
    }
  }, {
    key: "isLinkTracking",
    value: function isLinkTracking() {
      return !!this.link_tracking;
    }
  }, {
    key: "getTraffic",
    value: function getTraffic() {
      var _this$traffic;

      return (_this$traffic = this.traffic) === null || _this$traffic === void 0 ? void 0 : _this$traffic.toLocaleString();
    }
  }, {
    key: "getConversions",
    value: function getConversions() {
      var _this$conversion;

      return (_this$conversion = this.conversion) === null || _this$conversion === void 0 ? void 0 : _this$conversion.toLocaleString();
    }
  }, {
    key: "getConversionDollarFormatted",
    value: function getConversionDollarFormatted() {
      return (0, _numbers.priceWithCurrency)(this.conversion_dollar);
    }
  }, {
    key: "getValueFormatted",
    value: function getValueFormatted() {
      return (0, _numbers.priceWithCurrency)(this.value);
    }
  }, {
    key: "getCostFormatted",
    value: function getCostFormatted() {
      return (0, _numbers.priceWithCurrency)(this.cost);
    }
  }, {
    key: "getTotalReachFormatted",
    value: function getTotalReachFormatted() {
      var _this$total_reach;

      return (0, _numbers.compactIntWithDecimals)((_this$total_reach = this.total_reach) !== null && _this$total_reach !== void 0 ? _this$total_reach : 0, 1);
    }
  }, {
    key: "getTotalImpressionsFormatted",
    value: function getTotalImpressionsFormatted() {
      var _this$total_impressio;

      return (0, _numbers.compactIntWithDecimals)((_this$total_impressio = this.total_impressions) !== null && _this$total_impressio !== void 0 ? _this$total_impressio : 0, 1);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      var today = (0, _moment["default"])();
      var startDate = (0, _moment["default"])(this.starts_at).startOf('day');
      var endDate = (0, _moment["default"])(this.ends_at).endOf('day');
      return today.isBetween(startDate, endDate);
    }
  }, {
    key: "getROI",
    value: function getROI() {
      var result = this.cost === 0 || this.value === undefined || this.cost === undefined ? 0 : (this.value - this.cost) / this.cost * 100;
      return result.toFixed(2) + '%';
    }
  }, {
    key: "isBeingUpdated",
    value: function isBeingUpdated() {
      return this.$$uiPending;
    }
  }]);

  return Campaign;
}();

exports.Campaign = Campaign;